import React from 'react';

import MuiDialogContent, {
  DialogContentProps as MuiDialogContentProps,
} from '@mui/material/DialogContent';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const DialogContent = withCoreProps<DialogContentProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<DialogContentProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiDialogContent {...props} className={clsxClass}>
        {children}
      </MuiDialogContent>
    );
  },
);

export interface DialogContentProps extends MuiDialogContentProps, CoreProps {}
